import { Field, Form, Formik } from "formik";
import "moment-timezone";
import React from "react";
import { Button, ControlLabel } from 'react-bootstrap';
import { useHistory } from "react-router";
import Alert from "react-s-alert";
import * as Yup from "yup";
import FormikFormControl from '../../Shared/Forms/FormikFormControl';
import UsersService from "../../utils/UsersService";

const UserNewForm = ({ title, onSubmit, onCancelSubmit }) => {
  const history = useHistory()

    const validationSchema = Yup.object().shape({
      first_name: Yup.string().required("is required").max(30, "maximum 30 characters"),
      last_name: Yup.string().required("is required").max(30, "maximum 30 characters"),
      email: Yup.string().required().max(100, "maximum 100 characters").email("doesn't look like a valid email address"),
    });

    return (
      <Formik
        initialValues={{
          first_name: "",
          last_name: "",
          email: "",
        }}
        validationSchema={validationSchema}
        onSubmit={(values, { setSubmitting }) => {
          setSubmitting(true);

          UsersService.create(values)
            .then(data => {
              Alert.success('New user created')
              onSubmit(data)
              setSubmitting(false);
              history.push(`/m1/users/${data.id}`);
            });
        }}
        render={({
          errors,
          touched,
          isValid,
          isSubmitting,
          values,
          setFieldValue,
          setFieldTouched,
        }) => (
          <Form>
            <FormikFormControl
              fieldName="first_name"
              errors={errors}
              touched={touched}
            >
              <ControlLabel>First Name</ControlLabel>
              <Field type="text" name="first_name" className="form-control" />
            </FormikFormControl>

            <FormikFormControl
              fieldName="last_name"
              errors={errors}
              touched={touched}
            >
              <ControlLabel>Last Name</ControlLabel>
              <Field type="text" name="last_name" className="form-control" />
            </FormikFormControl>

            <FormikFormControl
              fieldName="email"
              errors={errors}
              touched={touched}
            >
              <ControlLabel>Email</ControlLabel>
              <Field type="text" name="email" className="form-control" />
            </FormikFormControl>

            <div>
              {onCancelSubmit && (
                <Button onClick={onCancelSubmit} bsSize="small">
                  Whoops, cancel this
                </Button>
              )}
              <Button
                className="pull-right"
                disabled={!isValid || isSubmitting}
                type="submit"
                bsStyle="primary"
                bsSize="small"
              >
                Create User
              </Button>
            </div>
          </Form>
        )}
      />
    );
}

export default UserNewForm